export const getJackpotName = () => {
  return window.OPWrapperService.config.jackpotEnabled ?
    window.OPWrapperService.localizations.getLocalizedText('jackpot') : 'Air Drop';
}
